/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Stop_WaitingInputs */

const en_us2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop waiting`)
};

const pt_br2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de esperar`)
};

const es_419_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de esperar`)
};

const pt_pt2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar de esperar`)
};

const fr_fr2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus attendre`)
};

const de_de2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht mehr warten`)
};

const it_it2_coach_stop_waiting = /** @type {(inputs: Coach_Stop_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smetti di aspettare`)
};

/**
* | output |
* | --- |
* | "Stop waiting" |
*
* @param {Coach_Stop_WaitingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_stop_waiting = /** @type {((inputs?: Coach_Stop_WaitingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Stop_WaitingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_stop_waiting(inputs)
	if (locale === "es-419") return es_419_coach_stop_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_stop_waiting(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_stop_waiting(inputs)
	if (locale === "de-DE") return de_de2_coach_stop_waiting(inputs)
	if (locale === "it-IT") return it_it2_coach_stop_waiting(inputs)
	return en_us2_coach_stop_waiting(inputs)
});
export { coach_stop_waiting as "coach.stop_waiting" }